import {
  AddressInfoDto,
  REQUEST_LINE_STATUS,
  RequestLineStatus,
} from '@savgroup-front-common/types';

import messages from './messages';

interface MessageType {
  id: string;
  defaultMessage: string;
}

export const getStatusText = (status: RequestLineStatus): MessageType => {
  if (status === REQUEST_LINE_STATUS.ORDER_DELIVERED) {
    return messages.statusValueDelivered;
  }
  if (status === REQUEST_LINE_STATUS.ORDER_SHIPPED) {
    return messages.statusValueShipped;
  }
  if (status === REQUEST_LINE_STATUS.TO_PROCESS) {
    return messages.statusValueToProcess;
  }

  return messages.statusValueSubmitted;
};

export const getAdressText = (deliveryAddress: AddressInfoDto): string => {
  return `${deliveryAddress.address}, ${deliveryAddress.postalCode} ${deliveryAddress.city}`;
};
